import { ParticleEngine } from './particles'

export class Profiler {
  private fpsCounterElement: HTMLDivElement | undefined
  private lastFrameTimes: number[] = []
  private currentFps: number = -1

  constructor(readonly particleEngine: ParticleEngine) {
  }

  public startBenchmark = () => {
    this.particleEngine.resetParticles()
    const TOTAL_LENGTH = 10000
    const fps: number[] = []

    const cancelIdSpawn = setInterval(() => {
      this.particleEngine.spawnParticles({
        nrOfParticles: 3000,
        lifespan: { value: 30, randomness: 30 },
        color: {
          value: '#ff0000',
          randomness: 100
        },
        bounciness: { value: 0.5, randomness: 10 },
        radius: { value: 10, randomness: 50 }
      })
    }, 2000)

    const cancelIdFps = setTimeout(() => setInterval(() => {
      fps.push(this.currentFps)
    }, 50), 2000)

    setTimeout(() => {
      clearInterval(cancelIdSpawn)
      clearInterval(cancelIdFps)
      alert(`Avg FPS: ${ Math.round(fps.reduce((acc, current) => acc + current, 0) / fps.length) }`)
      this.particleEngine.resetParticles()
    }, TOTAL_LENGTH)
  }

  public updateFpsCounter(deltaTimeMs: number) {
    const fpsCounterElement = this.getElement()
    if (!fpsCounterElement) {
      return
    }

    this.lastFrameTimes.push(deltaTimeMs)
    if (this.lastFrameTimes.length >= 30) {
      const avg = this.lastFrameTimes.reduce((current, acc) => acc + current, 0) / this.lastFrameTimes.length
      const avgFps = 1 / (avg / 1000)
      const fpsRounded = Math.round(avgFps)
      fpsCounterElement.innerText = fpsRounded + ' fps'
      this.lastFrameTimes = []
      this.currentFps = fpsRounded
    }
  }

  private getElement() {
    if (this.fpsCounterElement === undefined) {
      this.fpsCounterElement = document.getElementById('fps') as HTMLDivElement
    }
    return this.fpsCounterElement
  }


  public startRenderDrawBench() {
    this.particleEngine.resetParticles()
    const TOTAL_LENGTH = 10000
    const fps: number[] = []

    const collisionSettingsBefore = this.particleEngine.collisionsEnabled
    this.particleEngine.collisionsEnabled = false

    this.particleEngine.spawnParticles({
      nrOfParticles: 50000,
      lifespan: { value: 30, randomness: 30 },
      color: {
        value: '#ff0000',
        randomness: 100
      },
      bounciness: { value: 0.5, randomness: 10 },
      radius: { value: 10, randomness: 50 }
    })

    const cancelId = setTimeout(() => setInterval(() => {
      fps.push(this.currentFps)
    }, 50), 2000)

    setTimeout(() => {
      clearInterval(cancelId)
      console.log(fps)
      alert(`Avg FPS: ${ Math.round(fps.reduce((acc, current) => acc + current, 0) / fps.length) }`)
      this.particleEngine.resetParticles()
      this.particleEngine.collisionsEnabled = collisionSettingsBefore

    }, TOTAL_LENGTH)
  }

}




